'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var Store = require('orbit-db-store');

var KeyValueIndex = require('./KeyValueIndex');

var KeyValueStore = /*#__PURE__*/function (_Store) {
  _inherits(KeyValueStore, _Store);

  var _super = _createSuper(KeyValueStore);

  function KeyValueStore(ipfs, id, dbname, options) {
    var _this;

    _classCallCheck(this, KeyValueStore);

    var opts = Object.assign({}, {
      Index: KeyValueIndex
    });
    Object.assign(opts, options);
    _this = _super.call(this, ipfs, id, dbname, opts);
    _this._type = 'keyvalue';
    return _this;
  }

  _createClass(KeyValueStore, [{
    key: "all",
    get: function get() {
      return this._index._index;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._index.get(key);
    }
  }, {
    key: "set",
    value: function set(key, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.put(key, data, options);
    }
  }, {
    key: "put",
    value: function put(key, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._addOperation({
        op: 'PUT',
        key: key,
        value: data
      }, options);
    }
  }, {
    key: "del",
    value: function del(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._addOperation({
        op: 'DEL',
        key: key,
        value: null
      }, options);
    }
  }]);

  return KeyValueStore;
}(Store);

module.exports = KeyValueStore;